module.exports = __webpack_public_path__ + "img/HppProductionService.57844e81.png";